<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content qr_area">
				<h2 class="headline_m">
					{{ $t('rtr_personal-how-qr.title1') }}
					<br />
					{{ $t('rtr_personal-how-qr.title2') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-how-qr.text1') }}<br />{{
						$t('rtr_personal-how-qr.text2')
					}}<br />{{ $t('rtr_personal-how-qr.text3') }}
				</p>
				<div class="button_area">
					<button
						class="button_bg_red mr_10"
						@click="$router.push({ name: 'auth-register' })"
					>
						{{ $t('button.signup') }}
					</button>
					<button
						class="button_bg_black"
						@click="$router.push({ name: 'auth-login' })"
					>
						{{ $t('auth.login_btn') }}
					</button>
				</div>
			</div>
		</div>
		<section>
			<div class="content_area type_2 bg_gray1">
				<p class="title_m">
					{{ $t('rtr_personal-how-offline_kiosk.text12') }}<br />
					{{ $t('rtr_personal-how-offline_kiosk.text13') }}
				</p>
				<div>
					<swiper :centered-slides="true" :slides-per-view="1.5">
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/qr_rectangle_01.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-how-qr.text5') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-how-qr.text6')
										}}{{ $t('rtr_personal-how-qr.text7') }}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/qr_rectangle_02.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-how-qr.text8') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-how-qr.text9')
										}}{{ $t('rtr_personal-how-qr.text10')
										}}{{ $t('rtr_personal-how-qr.text11') }}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/qr_rectangle_03.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-how-qr.text12') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-how-qr.text13')
										}}{{ $t('rtr_personal-how-qr.text14') }}
									</p>
								</div>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</section>

		<section class="content_area">
			<p class="title_m ma_0">
				{{ $t('rtr_personal-how-qr.text15') }}
				<br /><span class="fc_red fw_bold">{{
					$t('rtr_personal-how-qr.text16')
				}}</span
				>{{ $t('rtr_personal-how-qr.text17') }}
			</p>
			<div>
				<swiper :slides-per-view="1" :navigation="true" :modules="modules">
					<swiper-slide>
						<div class="slide_item pb_0">
							<div class="rectangle_qr">
								<p class="title_m ma_0 fs_18">
									<span class="fc_red">{{
										$t('rtr_personal-how-qr.text29')
									}}</span
									>{{ $t('rtr_personal-how-qr.text30') }}
								</p>
								<div class="icon">
									<img src="@/assets/images/sub/m_qr_step01.png" alt="" />
								</div>
								<p class="body_m ma_0">
									{{ $t('rtr_personal-how-qr.text21') }}
									{{ $t('rtr_personal-how-qr.text22')
									}}{{ $t('rtr_personal-how-qr.text23') }}
								</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="slide_item pb_0">
							<div class="rectangle_qr">
								<p class="title_m ma_0 fs_18">
									<span class="fc_red">{{
										$t('rtr_personal-how-qr.text31')
									}}</span
									>{{ $t('rtr_personal-how-qr.text32') }}
								</p>
								<div class="icon">
									<img src="@/assets/images/sub/m_qr_step02.png" alt="" />
								</div>
								<p class="body_m ma_0">
									{{ $t('rtr_personal-how-qr.text24') }}
								</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="slide_item pb_0">
							<div class="rectangle_qr">
								<p class="title_m ma_0 fs_18">
									<span class="fc_red">{{
										$t('rtr_personal-how-qr.text33')
									}}</span
									>{{ $t('rtr_personal-how-qr.text34') }}
								</p>
								<div class="icon">
									<img src="@/assets/images/sub/m_qr_step03.png" alt="" />
								</div>
								<p class="body_m ma_0">
									{{ $t('rtr_personal-how-qr.text25') }}
								</p>
							</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</section>
		<section>
			<div class="sub_content qr_flex">
				<div class="detail qr_sale">
					<h2 class="headline_s">
						{{ $t('rtr_personal-how-qr.title3') }}<br />
						{{ $t('rtr_personal-how-qr.title4') }}
					</h2>
					<p class="body_m mb_40">
						{{ $t('rtr_personal-how-qr.text26') }}
						{{ $t('rtr_personal-how-qr.text27') }}
						{{ $t('rtr_personal-how-qr.text28') }}
					</p>
				</div>
				<div class="img_area">
					<img
						src="@/assets/images/sub/business_people_using_their_phones.png"
						alt=""
					/>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import '@/assets/css/sub.m.css';
import { Pagination, Navigation } from 'swiper';
export default {
	name: 'Qr.m',
	setup() {
		return {
			modules: [Pagination, Navigation],
		};
	},
};
</script>
<style scoped></style>
